import { TableRow, TableRowProps, SxProps } from '@mui/material';
import { rowStyles, rowClickableStyles } from './styles';
import { MyTheme } from 'src/theme';

export function DefaultTableRow(props: TableRowProps): React.JSX.Element {
  return (
    <TableRow
      sx={{
        ...rowStyles,
        ...(props.onClick ? rowClickableStyles : {}),
      } as SxProps<MyTheme>}
      {...props}
    />
  );
}
